import React from 'react';
import { Box, keyframes } from '@mui/material';

const waveAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-5px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

interface WaveAnimationProps {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
}

const WaveAnimation: React.FC<WaveAnimationProps> = ({ 
  children, 
  delay = 0, 
  duration = 0.6 
}) => {
  return (
    <Box
      sx={{
        animation: `${waveAnimation} ${duration}s cubic-bezier(0.25, 0.46, 0.45, 0.94) ${delay}s both`,
      }}
    >
      {children}
    </Box>
  );
};

export default WaveAnimation;
